import React from "react";
import "./ToDo.css";
import Header from "../layouts/Employee/Header";
import SubHeader from "../layouts/Employee/SubHeader";

export default function ToDo() {
  return (
    <div id="todoPage">
      <Header />
      <SubHeader />
      {/* ===== Board Section ===== */}
      <section className="board-header">
        <h2>Redney</h2>
        <div className="board-info">
          <span>Today is Tuesday, February 24th 2025</span>
          <span className="board-name">Board → Daily Tasks</span>
          <div className="avatars">
            {/* Example avatars */}
            <img src="https://i.pravatar.cc/40?img=7" alt="user"/>
            <img src="https://i.pravatar.cc/40?img=9" alt="user"/>
            <span className="more">+12</span>
          </div>
          <div className="board-buttons">
            <button className="filter-btn">Filters</button>
            <button className="upload-btn">+ Upload Task</button>
          </div>
        </div>
      </section>

      {/* ===== Columns ===== */}
      <div className="columns">
        {["Todo list", "In Progress", "In Review", "Done"].map((col, i) => (
          <div key={i} className="column">
            <div className="column-header">
              <h3>{col}</h3>
              <button className="add-btn">+</button>
            </div>

            {/* Example Card */}
            <div className="card">
              <div className="tags">
                <span className="tag">Feedback</span>
                <span className="tag">Rednet</span>
              </div>
              <h4>Search inspiration for upcoming projects</h4>
              <p className="note">Note: They due on between project Mate</p>
              <div className="progress">
                <div className="bar" style={{width:"70%"}}></div>
              </div>
              <div className="card-footer">
                <div className="avatars">
                  <img src="https://i.pravatar.cc/40?img=1" alt="user"/>
                  <img src="https://i.pravatar.cc/40?img=2" alt="user"/>
                </div>
                <div className="card-actions">
                  <span><i className="fa-regular fa-comment"></i> 12</span>
                  <span><i className="fa-regular fa-paperclip"></i> 3</span>
                </div>
              </div>
            </div>
            {/* repeat more cards */}
          </div>
        ))}
      </div>
    </div>
  );
}
